import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "person" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "person-name pl-1" }

import TopBarButton from "@/components/topbar/TopBarButton.vue";
import { ref } from "vue";
import DescriptionModal from "@/components/util/DescriptionModal.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useModal, ModalsContainer } from "vue-final-modal";

const homePageLink =
  "https://abb.sharepoint.com/sites/NO-CompetenceLibrary/SitePages/TeamView.aspx";
const requestHelpLink =
  "https://abb.sharepoint.com/sites/NO-CompetenceLibrary/Lists/BUOGCSupport/AllItems.aspx?Application=U3t";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const Authorization = useAuthenticationStore();

const createBlobUrl = (photo: any) => {
  if (photo) {
    const blob = Authorization.getPhoto();
    return URL.createObjectURL(blob);
  }
  return undefined;
};

const descriptionModal = ref<{ open: () => void }>();
const openDescriptionModal = () => {
  descriptionModal.value?.open();
};

const { open, close } = useModal({
    component: DescriptionModal,
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-house",
        title: "Home",
        href: homePageLink,
        class: "btn-toolbox--home"
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "top-bar-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        (!_unref(Authorization).getPhotoLoader())
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: createBlobUrl(_unref(Authorization).getPhoto),
              alt: "User Photo",
              class: "person-photo person-photo--rounded"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(Authorization).getAccountName()), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "spacer" }, null, -1)),
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-info",
        title: "Description",
        onClick: _unref(open)
      }, null, 8, ["onClick"]),
      _createVNode(TopBarButton, {
        icon: "fa-solid fa-question-circle",
        title: "Request help",
        href: requestHelpLink,
        target: "_blank"
      })
    ]),
    _createVNode(_unref(ModalsContainer))
  ], 64))
}
}

})